// Display label for a customer in dropdowns: "Name (phone)".
// Keeps the phone number visible so users can disambiguate customers with
// similar names.
const customerLabel = (customer) => {
  if (!customer) return "";
  const name = customer.name || "";
  return customer.phone ? `${name} (${customer.phone})` : name;
};

export default customerLabel;
